export const GIFT_OPTION_DEFAULT = '0';
export const GIFT_OPTION_CUSTOM = '1';

export const GIFT_SUM_DEFAULT = '0';
export const GIFT_SUM_CUSTOM = '1';

export const GIFT_SEND_NOW = '0';
export const GIFT_SEND_CUSTOM = '1';

export const DEFAULT_PRICE = 2990;

export const TYPE_RECIPIENT_PERSON = 'person';
export const TYPE_RECIPIENT_ME = 'me';

export const DELIVERY_WAY_EMAIL = 'email';
export const DELIVERY_WAY_SMS = 'sms';

export const CUSTOM_CERT_ID_DEV = 768; // после апдейта базы продовыми данными стало одинаково
export const CUSTOM_CERT_ID_PROD = 768;

export const breadcrumbsPath = [
  { title: 'Главная', url: '/' },
  { title: 'Сертификаты', url: '' },
];
